import headerImgEn from "assets/images/v121/header-en.webp"
import infoImgEn from "assets/images/v121/info-en.webp"

export const v121ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
